module.exports = __webpack_public_path__ + "0bec0facd884b66fa5226e377d675285.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/disney_2023_chart.png
// module id = 1664
// module chunks = 0